export default import.meta.ROLLDOWN_FILE_URL_wG0Am3PoLp$6Qj4KrWO8_A